import React/*, { useState, useEffect, Fragment }*/ from 'react';
import CompanyLogo from '../containers/CompanyLogo';
import { Button, Grid } from '@mui/material';
import ReadMore from './ReadMore';

export default function CatCardContent(props) {
    const selectedObject = props.selectedObject || {}
    const selectedjobbgcolor = props.selectedjobbgcolor
    const applyOnTop = props.applyOnTop
    const view = props.view

    return (
        <div className="card rtl" >
            <div className="cardHeader" style={{backgroundColor:selectedjobbgcolor}}>
                <div className="cardHeaderContent">
                    <div className="jobTitleSection">
                        <div className="jobTitle">
                            {selectedObject.title || ''}
                        </div>
                    </div>
                    <div className="jobInfoSection">
                        <CompanyLogo companyName='JobHunt' companyUrl='jobhunt.co.il' className="cardLogo"/>
                        <div className="jobInfoSectionInner rtl">
                            <div className="jobCompany">JobHunt</div>
                            <div className="jobLocation">Israel</div>
                            {/*<Contact direction={selectedObject.direction} type="jobs"/>*/}
                        </div>
                    </div>
                </div>
            </div>
            <div className="cardFooter">
                <div className="applySection">
                    <div className="buttonContainer">
                        <div className="apply" style={{direction: 'ltr'}}>
                            <Button className={"apply" + ((applyOnTop)?"":"")} 
                                style={{marginRight:8}} 
                                variant="contained" color="primary" 
                                href={`https://jobhunt.co.il/?career&source=JobSwipe`}
                                target='_blank' rel="noopener noreferrer"
                            >בדיקת התאמה</Button>
                            <Button className={"apply" + ((applyOnTop)?"":"")} 
                                style={{marginRight:8}} 
                                variant="outlined" color="primary" 
                                href={`https://jobhunt.co.il`}
                                target='_blank' rel="noopener noreferrer"
                            >מידע נוסף</Button>
                        </div>
                    </div>
                </div>
                {
                //<a style={{color: '#1861bf'}} target='_blank' rel="noopener noreferrer" href={`https://jobhunt.co.il/?career&source=JobSwipe&param=${CATObj.source}`}>לבדיקת התאמה</a>
                }
                <div className="jobBadge" style={{direction: 'rtl', textAlign: 'right', marginBottom: 16}}>
                    <span className="name" style={{marginLeft: 12, display: 'initial'}}>3.4 חודשים</span>
                    <span>זמן ממוצע למציאת עבודה עם ג'ובאנט</span>
                </div>
                <Grid container spacing={1}>
                    <Grid item sm={7} xs={12}>
                        {(selectedObject.description)&&<ReadMore view={view}>{selectedObject.description}</ReadMore>}
                    </Grid>
                    <Grid item sm={5} xs={12}>
                        <img style={{maxWidth: '100%'}} src="https://drive.google.com/thumbnail?id=1ayLMBph0sClMszW9KcHEtdJoZbuIx6C2&sz=w1000" alt='JobHunt'/>
                    </Grid>
                </Grid>
                <div className="applySection">
                    <div className="buttonContainer">
                    <div className="apply" style={{direction: 'ltr'}}>
                            <Button className={"apply"} 
                                style={{marginRight:8}} 
                                variant="contained" color="primary" 
                                href={`https://jobhunt.co.il/?career&source=JobSwipe`}
                                target='_blank' rel="noopener noreferrer"
                            >בדיקת התאמה</Button>
                            <Button className={"apply"} 
                                style={{marginRight:8}} 
                                variant="outlined" color="primary" 
                                href={`https://jobhunt.co.il/recommendations/`}
                                target='_blank' rel="noopener noreferrer"
                            >המלצות</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}